import { z } from 'zod';

export const patientOverviewSchema = z.object({
  details: z.array(z.string()),
  reasonForVisit: z.array(z.string()),
});

export type PatientOverviewType = z.infer<typeof patientOverviewSchema>;
